export const roundPricesDown = (body, bookingTotalPrice) => {
    const bookings = body?.bookings;

    if (!bookings || !Array.isArray(bookings)) {
        return body;
    }

    const roundedBookings = bookings.map((item) => {
        const price = Number(item.price) || 0;
        return {
            ...item,
            price: Math.floor(price),
        };
    });

    const sumRoundedPrices = roundedBookings.reduce((total, booking) => total + booking.price, 0);
    const difference = bookingTotalPrice - sumRoundedPrices;

    if (difference > 0) {
        roundedBookings[0] = {
            ...roundedBookings[0],
            price: roundedBookings[0].price + difference,
        };
    }

    return {
        ...body,
        bookings: roundedBookings,
    };
};

export const activePaymentPackage = (checkoutInformationPackage, offerAccepted) => {
    if (
        checkoutInformationPackage?.cancellation_policy?.fixed_cancellation ||
        checkoutInformationPackage?.cancellation_policy?.percentage_cancellation || 
        offerAccepted
    ) {
        return true;
    }
    return false;
};

export const isValidCheckout = (selectedPackages, singleServices) => {
    const hasPackages = selectedPackages.length > 0;
    const hasServices = singleServices.length > 0;

    if (!hasPackages && hasServices) return "services";
    if (hasPackages && !hasServices) return "onlyPackages";
    if (hasPackages && hasServices) return "packagesAndServices";
};